import React from 'react';
import { withErrorBoundary } from '@nile/components';
import { withRouter } from 'react-router-dom';
import DashboardHome from '@nile/reports/src/modules/home/components/pages/Home';

function TvDashboardView(props) {
  return (
    <>
      <DashboardHome isTvDashboard={true} />
    </>
  );
}

export default withRouter(withErrorBoundary(TvDashboardView));
